/**
 @author huangjiaojiao
 @date 2020/4/13 13:46 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
// 获取当前用户创建的组列表
export const creatGroupList = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupListByUserId?"+ qs.stringify(data),
        method: "get",
    })
};
// 获取组成员信息
export const getGroupMembersInfo = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupMembersInfo?"+ qs.stringify(data),
        method: "get",
    })
};
// 获取用户所属组列表
export const GetUserGroupListByUserId = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetUserGroupListByUserId?"+ qs.stringify(data),
        method: "get",
    })
};
// 解散组
export const RemoveGroup = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/RemoveGroup?"+ qs.stringify(data),
        method: "get",
    })
};
// 修改组成员权限
export const SetGroupMembersAccess = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/SetGroupMembersAccess?"+ qs.stringify(data),
        method: "get",
    })
};
// 修改全组成员权限
export const SetGroupAccess = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/SetGroupAccess?"+ qs.stringify(data),
        method: "get",
    })
};
// 移除组成员
export const RemoveGroupMembers = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/RemoveGroupMembers?"+ qs.stringify(data),
        method: "get",
    })
};
// 获取组成员权限
export const GetGroupMembersAccess = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupMembersAccess?"+ qs.stringify(data),
        method: "get",
    })
};
// 获取整组的权限
export const GetGroupAccess = async (data) => {
    // debugger
    return axios.ajax({
        url: baseUrl.xy[1] + "/GetGroupAccess?"+ qs.stringify(data),
        method: "get",
    })
};


